import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function EducationStatsChart({ stats }) {
  // Example chart: visualize all four stats as bars
  const data = {
    labels: [
      "Participants",
      "Quizzes Completed",
      "Avg. Score",
      "Highest Score"
    ],
    datasets: [
      {
        label: "Education Stats",
        data: [
          stats.total_users,
          stats.total_completed_quizzes,
          stats.average_score,
          stats.highest_score
        ],
        backgroundColor: [
          "#ec4899",
          "#22c55e",
          "#3b82f6",
          "#facc15"
        ],
        borderRadius: 8,
        maxBarThickness: 48
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: false }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { color: "#a1a1aa" },
        grid: { color: "#23272f" }
      },
      x: {
        ticks: { color: "#a1a1aa" },
        grid: { color: "#23272f" }
      }
    }
  };

  return (
    <div className="bg-[#181c23] rounded-xl border border-[#23272f] shadow-md p-6 mt-8">
      <h3 className="text-lg font-semibold text-white mb-4">Education Overview</h3>
      <Bar data={data} options={options} height={220} />
    </div>
  );
}
